import React from 'react';
import { TextFieldProps } from 'mui-rff';
import { onlyNCharacters, onlyNumbers } from 'utils/formatters';
import Input from '../Input';

const PINInput = (props: TextFieldProps) => (
  <Input
    type="password"
    fieldProps={{
      parse: (value: string) => onlyNCharacters(5)(onlyNumbers(value)),
    }}
    placeholder="_ _ _ _ _"
    InputLabelProps={{
      shrink: true,
    }}
    {...props}
  />
);

export default PINInput;
